import { ListGroup, ListGroupItem, Button } from "reactstrap";
import React, { FunctionComponent } from "react";

const TSModules: FunctionComponent<any> = ({ modules }) => {
  return (
    <ListGroup>
      {
        modules.map((module: any) => (
          <ListGroupItem className="list-group-item  d-flex justify-content-between">
            <b>{ module } </b>
          </ListGroupItem>
        ))
      }
    </ListGroup>
  )
}

export default TSModules;
